//NATAL CHART from rinoa - updated tips: has now 3 boxes.

import React, { useEffect, useState } from "react";
import axios from "axios";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import TipsChatbot from './ChatBot/TipsChatbot';
import { useTranslation } from 'react-i18next';
import { t } from "i18next";
// Slide box always visible on the right
// const TipBox = ({ period, tips, currentIndex, onPrev, onNext }) => {
//   const tip = tips[currentIndex] || { title: "", content: "No tip available." };

//   return (
//     <div
//       style={{
//         backgroundColor: "#000",
//         color: "#DFBD69",
//         border: "2px solid #DFBD69",
//         padding: "15px",
//         marginBottom: "20px",
//         width: "100%",
//         fontFamily: "Arial, sans-serif",
//         boxShadow: "0 0 12px #DFBD69",
//       }}
//     >
//       <h3
//         style={{
//           borderBottom: "1px solid #DFBD69",
//           fontSize: "22px",
//           paddingBottom: "8px",
//         }}
//       >
//         💡 {period} Tip
//       </h3>
//       <strong style={{ fontSize: "18px" }}>{tip.title}</strong>
//       <p style={{ color: "#DFBD69", fontSize: "16px", whiteSpace: "pre-wrap" }}>
//         {tip.content}
//       </p>
//       <div
//         style={{
//           display: "flex",
//           justifyContent: "space-between",
//           marginTop: "10px",
//         }}
//       >
//         <button onClick={onPrev} style={navButtonStyle}>
//           Previous
//         </button>
//         <button onClick={onNext} style={navButtonStyle}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

const navButtonStyle = {
  backgroundColor: "#DFBD69",
  border: "none",
  color: "#000",
  padding: "5px 10px",
  borderRadius: "4px",
  cursor: "pointer",
};

// const chartConfig = [
//   { label: "WEALTH", color: "#FFD700" },
//   { label: "CAREER", color: "#32CD32" },
//   { label: "RELATIONSHIP", color: "#1E90FF" },
//   { label: "HEALTH", color: "#FF6347" },
//   { label: "WISDOM", color: "#8A2BE2" },
// ];

const CircleContainer = ({ children }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "80px",
      marginBottom: "40px",
    }}
  >
    {children}
  </div>
);

// Add these at the top (after imports, before ForecastChart)
const getDirectIndirectScoreCategory = (value) => {
  const score = Number(value) || 0;
  if (score <= 10) return t('natalChart.turbulent');
  if (score > 10 && score <= 20) return t('natalChart.developing');
  if (score > 20 && score <= 30) return t('natalChart.fine');
  if (score > 30 && score <= 40) return t('natalChart.good');
  if (score > 40 && score <= 50) return t('natalChart.excellent');
  // For values outside 0-50, don't show an overall 'Wonderful' label
  return "";
};

// const ModalCircleProgress = ({ label, value, color, isMobile = false }) => {
//   // Clamp value to 0-50
//   const v = Math.max(0, Math.min(Number(value) || 0, 50));

//   // Segments: 0-10, 11-20, 21-30, 31-40, 41-50, 51-60
//   const segments = [
//     { min: 0, max: 10 },
//     { min: 10.00001, max: 20 },
//     { min: 20.00001, max: 30 },
//     { min: 30.00001, max: 40 },
//     { min: 40.00001, max: 50 },
//     { min: 50.00001, max: 60 },
//   ];

//   // Find the segment max for the value
//   const getSegmentMaxForValue = (val) => {
//     if (val === 0) return 0;
//     for (let i = 0; i < segments.length; i++) {
//       const seg = segments[i];
//       if (val > seg.min && val <= seg.max) return seg.max;
//     }
//     return 60;
//   };

//   const fillValue = getSegmentMaxForValue(v);
//   const fillPercent = fillValue / 60;

//   // SVG circle parameters
//   const size = isMobile ? 90 : 140;
//   const strokeWidth = isMobile ? 12 : 18;
//   const center = size / 2;
//   const radius = (size - strokeWidth) / 2;
//   const circumference = 2 * Math.PI * radius;
//   const offset = circumference - fillPercent * circumference;

//   // Separator positions (in degrees)
//   const separatorAngles = [0, 10, 20, 30, 40, 50, 60].map(
//     (val) => (val / 60) * 360
//   );

//   // Get the score category for the center
//   const scoreCategory = getDirectIndirectScoreCategory(v);

//   return (
//     <div style={{ marginBottom: "18px", textAlign: "center" }}>
//       <div style={{ fontWeight: "bold", color: "#DFBD69", fontSize: isMobile ? "14px" : "16px", marginBottom: 8 }}>
//         {label}
//       </div>
//       <div style={{ display: "inline-block", position: "relative" }}>
//         <svg width={size} height={size}>
//           {/* Background circle */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke="#1f1f1f"
//             strokeWidth={strokeWidth}
//             transform={`rotate(-90 ${center} ${center})`}
//           />
//           {/* Progress circle */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke={color}
//             strokeWidth={strokeWidth}
//             strokeDasharray={circumference}
//             strokeDashoffset={offset}
//             style={{
//               transition: "stroke-dashoffset 0.3s ease",
//               filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
//             }}
//             strokeLinecap="butt"
//             transform={`rotate(-90 ${center} ${center})`}
//           />
//           {/* Segment separators */}
//           {separatorAngles.map((angle, idx) => {
//             const rad = ((angle - 90) * Math.PI) / 180;
//             const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
//             const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
//             const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
//             const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);
//             return (
//               <line
//                 key={idx}
//                 x1={x1}
//                 y1={y1}
//                 x2={x2}
//                 y2={y2}
//                 stroke="#DFBD69"
//                 strokeWidth={isMobile ? 2 : 4}
//               />
//             );
//           })}
//         </svg>
//         {/* Center value: show score category */}
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             color: color,
//             fontWeight: "bold",
//             fontSize: isMobile ? "16px" : "18px",
//             pointerEvents: "none",
//           }}
//         >
//           {scoreCategory}
//         </div>
//       </div>
//     </div>
//   );
// };

// const ModalCircleProgress = ({ label, value, color, isMobile = false }) => {
//   // Clamp value to 0-50 (keep max at 50 as requested)
//   const v = Math.max(0, Math.min(Number(value) || 0, 50));

//   // Use exact value instead of rounding to segment max
//   const fillPercent = v / 50; // Direct percentage (0 to 1)

//   // SVG circle parameters
//   const size = isMobile ? 90 : 140;
//   const strokeWidth = isMobile ? 12 : 18;
//   const center = size / 2;
//   const radius = (size - strokeWidth) / 2;
//   const circumference = 2 * Math.PI * radius;
//   const offset = circumference - fillPercent * circumference;

//   // Separator positions (in degrees) - 5 lines at 10, 20, 30, 40, 50
//   const separatorAngles = [10, 20, 30, 40, 50].map(
//     (val) => (val / 50) * 360
//   );

//   return (
//     <div style={{ marginBottom: "18px", textAlign: "center" }}>
//       <div style={{ fontWeight: "bold", color: "#DFBD69", fontSize: isMobile ? "14px" : "16px", marginBottom: 8 }}>
//         {label}
//       </div>
//       <div style={{ display: "inline-block", position: "relative" }}>
//         <svg width={size} height={size}>
//           {/* Background circle */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke="#1f1f1f"
//             strokeWidth={strokeWidth}
//             transform={`rotate(-90 ${center} ${center})`}
//           />
//           {/* Progress circle */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke={color}
//             strokeWidth={strokeWidth}
//             strokeDasharray={circumference}
//             strokeDashoffset={offset}
//             style={{
//               transition: "stroke-dashoffset 0.3s ease",
//               filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
//             }}
//             strokeLinecap="butt"
//             transform={`rotate(-90 ${center} ${center})`}
//           />
//           {/* Segment separators - only 5 lines */}
//           {separatorAngles.map((angle, idx) => {
//             const rad = ((angle - 90) * Math.PI) / 180;
//             const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
//             const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
//             const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
//             const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);
//             return (
//               <line
//                 key={idx}
//                 x1={x1}
//                 y1={y1}
//                 x2={x2}
//                 y2={y2}
//                 stroke="#DFBD69"
//                 strokeWidth={isMobile ? 2 : 4}
//               />
//             );
//           })}
//         </svg>
//         {/* Center value: show actual number with 2 decimal places and % */}
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             color: color,
//             fontWeight: "bold",
//             fontSize: isMobile ? "16px" : "18px",
//             pointerEvents: "none",
//           }}
//         >
//           {v.toFixed(2)}%
//         </div>
//       </div>
//     </div>
//   );
// };
const ModalCircleProgress = ({ label, value, color, isMobile = false }) => {
  // Clamp value to 0-50 (keep max at 50 as requested)
  const v = Math.max(0, Math.min(Number(value) || 0, 50));

  // Use exact value instead of rounding to segment max
  const fillPercent = v / 50; // Direct percentage (0 to 1)

  // SVG circle parameters
  const size = isMobile ? 90 : 140;
  const strokeWidth = isMobile ? 12 : 18;
  const center = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - fillPercent * circumference;

  // Separator positions (in degrees) - 5 lines at 10, 20, 30, 40, 50
  const separatorAngles = [10, 20, 30, 40, 50].map(
    (val) => (val / 50) * 360
  );

  // Get score category for display
  const scoreCategory = getDirectIndirectScoreCategory(v);

  return (
    <div style={{ marginBottom: "18px", textAlign: "center" }}>
      <div style={{ fontWeight: "bold", color: "#DFBD69", fontSize: isMobile ? "14px" : "16px", marginBottom: 8 }}>
        {label}
      </div>
      <div style={{ display: "inline-block", position: "relative" }}>
        <svg width={size} height={size}>
          {/* Background circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="#1f1f1f"
            strokeWidth={strokeWidth}
            transform={`rotate(-90 ${center} ${center})`}
          />
          {/* Progress circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke={color}
            strokeWidth={strokeWidth}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            style={{
              transition: "stroke-dashoffset 0.3s ease",
              filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
            }}
            strokeLinecap="butt"
            transform={`rotate(-90 ${center} ${center})`}
          />
          {/* Segment separators - only 5 lines */}
          {separatorAngles.map((angle, idx) => {
            const rad = ((angle - 90) * Math.PI) / 180;
            const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
            const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
            const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
            const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);
            return (
              <line
                key={idx}
                x1={x1}
                y1={y1}
                x2={x2}
                y2={y2}
                stroke="#DFBD69"
                strokeWidth={isMobile ? 2 : 4}
              />
            );
          })}
        </svg>
        {/* Center value: show score category and actual value with 2 decimal places and % */}
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            textAlign: "center",
          }}
        >
          <div
            style={{
              fontSize: isMobile ? "14px" : "16px",
              fontWeight: "bold",
              color: color,
              marginBottom: "2px",
            }}
          >
            {scoreCategory}
          </div>
          <div
            style={{
              fontSize: isMobile ? "12px" : "14px",
              color: "#DFBD69",
            }}
          >
            {v.toFixed(2)}%
          </div>
        </div>
      </div>
    </div>
  );
};

const HorizontalBarChart = ({ label, value, color, onClick }) => {
  // ensure numeric 0-120
  const val = Math.max(0, Math.min(Number(value) || 0, 120));

  const segments = [
    { label: "0-20", min: 0, max: 20 },
    { label: "21-40", min: 21, max: 40 },
    { label: "41-60", min: 41, max: 60 },
    { label: "61-80", min: 61, max: 80 },
    { label: "81-100", min: 81, max: 100 },
    { label: "101-120", min: 101, max: 120 },
  ];

  // determine the fill to round up to the highest number in the segment
  // if value falls in the gap between segments (e.g. 40 < v < 41) we round up to the next segment
  const getSegmentMaxForValue = (v) => {
    if (v === 0) return 0;
    for (let i = 0; i < segments.length; i++) {
      const seg = segments[i];
      const next = segments[i + 1];
      // exact within segment
      if (v >= seg.min && v <= seg.max) return seg.max;
      // falls in the gap after this segment and before the next -> round up to next segment.max
      if (next && v > seg.max && v < next.min) return next.max;
    }
    return 120;
  };

  const fillValue = getSegmentMaxForValue(val); // e.g. 40.5 -> 60
  const fillPercent = `${(fillValue / 120) * 100}%`;

  // separator positions for 6 segments
  const separatorPositions = [20, 40, 60, 80, 100]; // fixed positions for 5 separators

  return (
    <div
      style={{
        marginBottom: "20px",
        width: "100%",
        maxWidth: "1000px",
        cursor: "pointer",
        padding: "10px",
        borderRadius: "8px",
        backgroundColor: "rgba(223, 189, 105, 0.05)",
        transition: "background-color 0.25s ease",
      }}
      onClick={onClick}
      onMouseOver={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.12)")
      }
      onMouseOut={(e) =>
        (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.05)")
      }
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "8px",
        }}
      >
        <span style={{ fontWeight: "bold", color: "#DFBD69" }}>{label}</span>
      </div>

      {/* segmented background */}
      <div
        style={{
          position: "relative",
          width: "100%",
          height: "28px",
          backgroundColor: "#1f1f1f",
          borderRadius: "14px",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
        }}
        aria-hidden
      >
        {/* segments visual (6 equal parts) */}
        {segments.map((s, idx) => (
          <div
            key={s.label}
            style={{
              width: `${100 / segments.length}%`,
              height: "100%",
              boxSizing: "border-box",
              borderRight:
                idx < segments.length - 1 ? "1px solid rgba(77, 69, 69, 1)" : "none",
            }}
          />
        ))}

        {/* colored fill overlay according to rounded-up segment max */}
        <div
          style={{
            position: "absolute",
            left: 0,
            top: 0,
            height: "100%",
            width: fillPercent,
            background: color,
            borderRadius: fillValue >= 120 ? "14px" : "14px 0 0 14px",
            transition: "width 0.3s ease",
            boxShadow: "inset 0 -2px 6px rgba(0,0,0,0.35)",
            zIndex: 1,
          }}
        />

        {/* separators on top of everything, both on fill and no fill */}
        {separatorPositions.map((pos, idx) => (
          <div
            key={idx}
            style={{
              position: "absolute",
              left: `${(pos / 120) * 100}%`, // position based on 120
              top: 0,
              bottom: 0,
              width: "4px",
              backgroundColor: "#DFBD69",
              transform: "translateX(-50%)",
              pointerEvents: "none",
              zIndex: 2,
            }}
          />
        ))}
      </div>
    </div>
  );
};

const SmallCircleProgress = ({ children, onClick }) => (
  <div style={{ width: "140px", textAlign: "center", cursor: "pointer" }} onClick={onClick} >{children}</div>
);

const ProgressBarContainer = ({ children }) => (
  <div style={{ 
    width: "140px", // Increased from 100px to 140px
    height: "100px", 
    margin: "0 auto",
    marginBottom: "70px" // Added margin bottom like in NatalChart.jsx
  }}>
    {children}
  </div>
);

const ForecastChart = () => {
  const [forecastTables, setForecastTables] = useState([]);
  const [tipsData, setTipsData] = useState({
    Daily: [],
    Monthly: [],
    Yearly: [],
  });
  const [currentTipIndex, setCurrentTipIndex] = useState({
    Daily: 0,
    Monthly: 0,
    Yearly: 0,
  });

  const [showChatbot, setShowChatbot] = useState(false);
  const [selectedTip, setSelectedTip] = useState(null);
  const [selectedCircle, setSelectedCircle] = useState(null);
  const [showTutorial, setShowTutorial] = useState(false);
  const [showTipsChatbot, setShowTipsChatbot] = useState(false);
  const [selectedChart, setSelectedChart] = useState(null);
  const [currentForecast, setCurrentForecast] = useState(null);
  const [chatbotContext, setChatbotContext] = useState(null);

  const { t, i18n } = useTranslation();
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  const chartConfig = [
    { key: 'WEALTH', label: t('natalChart.wealth'), color: "#FFD700" },
    { key: 'CAREER', label: t('natalChart.career'), color: "#32CD32" },
    { key: 'RS', label: t('natalChart.relationship'), color: "#1E90FF" },
    { key: 'HEALTH', label: t('natalChart.health'), color: "#FF6347" },
    { key: 'WISDOM', label: t('natalChart.wisdom'), color: "#8A2BE2" },
  ];

  const chartData = currentForecast ? {
    WEALTH: currentForecast.WEALTH_TOTAL || 0,
    CAREER: currentForecast.CAREER_TOTAL || 0,
    HEALTH: currentForecast.HEALTH_TOTAL || 0,
    RS: currentForecast.RS_TOTAL || 0,
    WISDOM: currentForecast.WISDOM_TOTAL || 0
  } : null;

  // Add this helper function near the top, after chartConfig
  const getScoreCategory = (value) => {
    const score = Number(value) || 0;
    if (score >= 0 && score <= 20) return t('natalChart.turbulent');
    if (score > 20 && score <= 40) return t('natalChart.developing');
    if (score > 40 && score <= 60) return t('natalChart.fine');
    if (score > 60 && score <= 80) return t('natalChart.good');
    if (score > 80 && score <= 100) return t('natalChart.excellent');
    // For values outside 0-100 return empty string (don't show 'Wonderful')
    return '';
  };

  // Replace HorizontalBarChart with CircularBarChart
//   const CircularBarChart = ({ label, value, color, onClick }) => {
//   // Clamp value to 0-100 (changed from 120)
//   const val = Math.max(0, Math.min(Number(value) || 0, 100));

//   // Use exact value instead of rounding to segment max
//   const fillPercent = val; // Direct value from 0-100

//   // SVG circle parameters
//   const size = 180;
//   const strokeWidth = 20;
//   const center = size / 2;
//   const radius = (size - strokeWidth) / 2;
//   const circumference = 2 * Math.PI * radius;

//   // Calculate dash offset for progress
//   const offset = circumference - (fillPercent / 100) * circumference;

//   // Separator positions (in degrees) - 5 lines at 20, 40, 60, 80, 100
//   const separatorAngles = [20, 40, 60, 80, 100].map(
//     (val) => (val / 100) * 360
//   );

//   return (
//     <div
//       style={{
//         marginBottom: "20px",
//         cursor: "pointer",
//         padding: "10px",
//         borderRadius: "8px",
//         transition: "background-color 0.25s ease",
//         display: "flex",
//         flexDirection: "column",
//         alignItems: "center",
//       }}
//       onClick={onClick}
//       onMouseOver={(e) =>
//         (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.12)")
//       }
//       onMouseOut={(e) =>
//         (e.currentTarget.style.backgroundColor = "transparent")
//       }
//     >
//       <div
//         style={{
//           fontWeight: "bold",
//           color: "#DFBD69",
//           marginBottom: "15px",
//           fontSize: "18px",
//         }}
//       >
//         {label}
//       </div>

//       <div style={{ position: "relative", width: size, height: size }}>
//         <svg width={size} height={size}>
//           {/* Background circle with segments */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke="#1f1f1f"
//             strokeWidth={strokeWidth}
//             transform={`rotate(-90 ${center} ${center})`}
//           />

//           {/* Progress circle */}
//           <circle
//             cx={center}
//             cy={center}
//             r={radius}
//             fill="none"
//             stroke={color}
//             strokeWidth={strokeWidth}
//             strokeDasharray={circumference}
//             strokeDashoffset={offset}
//             transform={`rotate(-90 ${center} ${center})`}
//             style={{
//               transition: "stroke-dashoffset 0.5s ease",
//               filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
//             }}
//           />

//           {/* Segment separators - 5 lines */}
//           {separatorAngles.map((angle, idx) => {
//             const rad = (angle * Math.PI) / 180;
//             const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
//             const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
//             const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
//             const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);

//             return (
//               <line
//                 key={idx}
//                 x1={x1}
//                 y1={y1}
//                 x2={x2}
//                 y2={y2}
//                 stroke="#DFBD69"
//                 strokeWidth="4"
//                 transform={`rotate(-90 ${center} ${center})`}
//               />
//             );
//           })}
//         </svg>

//         {/* Center text showing actual value with 2 decimal places and % */}
//         <div
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             textAlign: "center",
//           }}
//         >
//           <div
//             style={{
//               fontSize: "24px",
//               fontWeight: "bold",
//               color: color,
//             }}
//           >
//             {val.toFixed(2)}%
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };
  const CircularBarChart = ({ label, value, color, onClick }) => {
    // Clamp value to 0-100 (changed from 120)
    const val = Math.max(0, Math.min(Number(value) || 0, 100));

    // Use exact value instead of rounding to segment max
    const fillPercent = val; // Direct value from 0-100

    // SVG circle parameters
    const size = 180;
    const strokeWidth = 20;
    const center = size / 2;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;

    // Calculate dash offset for progress
    const offset = circumference - (fillPercent / 100) * circumference;

    // Separator positions (in degrees) - 5 lines at 20, 40, 60, 80, 100
    const separatorAngles = [20, 40, 60, 80, 100].map(
      (val) => (val / 100) * 360
    );

    // Get score category for display
    const scoreCategory = getScoreCategory(val);

    return (
      <div
        style={{
          marginBottom: "20px",
          cursor: "pointer",
          padding: "10px",
          borderRadius: "8px",
          transition: "background-color 0.25s ease",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        onClick={onClick}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.12)")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = "transparent")
        }
      >
        <div
          style={{
            fontWeight: "bold",
            color: "#DFBD69",
            marginBottom: "15px",
            fontSize: "18px",
          }}
        >
          {label}
        </div>

        <div style={{ position: "relative", width: size, height: size }}>
          <svg width={size} height={size}>
            {/* Background circle with segments */}
            <circle
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke="#1f1f1f"
              strokeWidth={strokeWidth}
              transform={`rotate(-90 ${center} ${center})`}
            />

            {/* Progress circle */}
            <circle
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke={color}
              strokeWidth={strokeWidth}
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              transform={`rotate(-90 ${center} ${center})`}
              style={{
                transition: "stroke-dashoffset 0.5s ease",
                filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
              }}
            />

            {/* Segment separators - 5 lines */}
            {separatorAngles.map((angle, idx) => {
              const rad = (angle * Math.PI) / 180;
              const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
              const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
              const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
              const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);

              return (
                <line
                  key={idx}
                  x1={x1}
                  y1={y1}
                  x2={x2}
                  y2={y2}
                  stroke="#DFBD69"
                  strokeWidth="4"
                  transform={`rotate(-90 ${center} ${center})`}
                />
              );
            })}
          </svg>

          {/* Center text showing score category and value with 2 decimal places and % */}
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                color: color,
                marginBottom: "4px",
              }}
            >
              {scoreCategory}
            </div>
            <div
              style={{
                fontSize: "16px",
                color: "#DFBD69",
              }}
            >
              {val.toFixed(2)}%
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const CircularBarChart = ({ label, value, color, onClick }) => {
  //   // ensure numeric 0-120
  //   const val = Math.max(0, Math.min(Number(value) || 0, 120));

  //   const segments = [
  //     { label: "0-20", min: 0, max: 20 },
  //     { label: "21-40", min: 20.00001, max: 40 },
  //     { label: "41-60", min: 40.00001, max: 60 },
  //     { label: "61-80", min: 60.00001, max: 80 },
  //     { label: "81-100", min: 80.00001, max: 100 },
  //     { label: "101-120", min: 100.00001, max: 120 },
  //   ];

  //   const getSegmentMaxForValue = (v) => {
  //     if (v === 0) return 0;
  //     for (let i = 0; i < segments.length; i++) {
  //       const seg = segments[i];
  //       // Check if value falls within this segment (use < instead of <= for max)
  //       if (v >= seg.min && v < seg.max) return seg.max;
  //       // If value equals exactly the segment max, it belongs to this segment
  //       if (v === seg.max) return seg.max;
  //     }
  //     // Values above 100 should fill to 120
  //     return 120;
  //   };
  //   const fillValue = getSegmentMaxForValue(val); // e.g. 60.89 -> 80
  //   const fillPercent = (fillValue / 120) * 100;

  //   // SVG circle parameters
  //   const size = 180;
  //   const strokeWidth = 20;
  //   const center = size / 2;
  //   const radius = (size - strokeWidth) / 2;
  //   const circumference = 2 * Math.PI * radius;

  //   // Calculate dash offset for progress
  //   const offset = circumference - (fillPercent / 100) * circumference;

  //   // Separator positions (in degrees) - aligned to start at 0 degrees (top)
  //   const separatorAngles = [20, 40, 60, 80, 100].map(
  //     (val) => (val / 120) * 360
  //   );

  //   // Get score category for display
  //   const scoreCategory = getScoreCategory(val);

  //   return (
  //     <div
  //       style={{
  //         marginBottom: "20px",
  //         cursor: "pointer",
  //         padding: "10px",
  //         borderRadius: "8px",
  //         transition: "background-color 0.25s ease",
  //         display: "flex",
  //         flexDirection: "column",
  //         alignItems: "center",
  //       }}
  //       onClick={onClick}
  //       onMouseOver={(e) =>
  //         (e.currentTarget.style.backgroundColor = "rgba(223, 189, 105, 0.12)")
  //       }
  //       onMouseOut={(e) =>
  //         (e.currentTarget.style.backgroundColor = "transparent")
  //       }
  //     >
  //       <div
  //         style={{
  //           fontWeight: "bold",
  //           color: "#DFBD69",
  //           marginBottom: "15px",
  //           fontSize: "18px",
  //         }}
  //       >
  //         {label}
  //       </div>

  //       <div style={{ position: "relative", width: size, height: size }}>
  //         <svg width={size} height={size}>
  //           {/* Background circle with segments */}
  //           <circle
  //             cx={center}
  //             cy={center}
  //             r={radius}
  //             fill="none"
  //             stroke="#1f1f1f"
  //             strokeWidth={strokeWidth}
  //             transform={`rotate(-90 ${center} ${center})`}
  //           />

  //           {/* Progress circle */}
  //           <circle
  //             cx={center}
  //             cy={center}
  //             r={radius}
  //             fill="none"
  //             stroke={color}
  //             strokeWidth={strokeWidth}
  //             strokeDasharray={circumference}
  //             strokeDashoffset={offset}
  //             transform={`rotate(-90 ${center} ${center})`}
  //             style={{
  //               transition: "stroke-dashoffset 0.5s ease",
  //               filter: "drop-shadow(0 0 6px rgba(0,0,0,0.35))",
  //             }}
  //           />

  //           {/* All segment separators - thick gold lines */}
  //           {separatorAngles.map((angle, idx) => {
  //             const rad = (angle * Math.PI) / 180;
  //             const x1 = center + (radius - strokeWidth / 2) * Math.cos(rad);
  //             const y1 = center + (radius - strokeWidth / 2) * Math.sin(rad);
  //             const x2 = center + (radius + strokeWidth / 2) * Math.cos(rad);
  //             const y2 = center + (radius + strokeWidth / 2) * Math.sin(rad);

  //             return (
  //               <line
  //                 key={idx}
  //                 x1={x1}
  //                 y1={y1}
  //                 x2={x2}
  //                 y2={y2}
  //                 stroke="#DFBD69"
  //                 strokeWidth="4"
  //                 transform={`rotate(-90 ${center} ${center})`}
  //               />
  //             );
  //           })}
  //         </svg>

  //         {/* Center text showing score category and value */}
  //         <div
  //           style={{
  //             position: "absolute",
  //             top: "50%",
  //             left: "50%",
  //             transform: "translate(-50%, -50%)",
  //             textAlign: "center",
  //           }}
  //         >
  //           <div
  //             style={{
  //               fontSize: "20px",
  //               fontWeight: "bold",
  //               color: color,
  //               marginBottom: "4px",
  //             }}
  //           >
  //             {scoreCategory}
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };

  // Update BarContainer to CircleContainer
  const CircleBarContainer = ({ children }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        flexWrap: "wrap",
        gap: "30px",
        marginBottom: "40px",
        width: "100%",
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );

  const getChartDataForChatbot = () => {
    if (!chatbotContext || !forecastTables.length) return null;
    let table = null;
    if (chatbotContext.period === "Daily") table = forecastTables[0];
    else if (chatbotContext.period === "Monthly") table = forecastTables[1];
    else if (chatbotContext.period === "Yearly") table = forecastTables[2];
    if (!table) return null;
    return {
      WEALTH: table.WEALTH_TOTAL || 0,
      CAREER: table.CAREER_TOTAL || 0,
      HEALTH: table.HEALTH_TOTAL || 0,
      RS: table.RS_TOTAL || 0,
      WISDOM: table.WISDOM_TOTAL || 0,
    };
  };
  const chartDataForChatbot = getChartDataForChatbot();

  const selectedChartLabel =
    chatbotContext && typeof chatbotContext.categoryIndex === "number"
      ? chartConfig[chatbotContext.categoryIndex].key
      : "WEALTH";

  const handleCircleClick = async (period, categoryIndex) => {
    let table = null;
    if (period === "Daily") table = forecastTables[0];
    else if (period === "Monthly") table = forecastTables[1];
    else if (period === "Yearly") table = forecastTables[2];

    if (!table) return;

    // Get the chart label for the clicked circle
    const config = chartConfig[categoryIndex];
    const chartLabel = config.key;
    //const chartLabel = config.label === "RELATIONSHIP" ? "RS" : config.label;

    // Fetch three tips for the selected chart
    const threeTips = await getThreeTipsForChart(period, chartLabel, table, lunarData);

    // Set the first tip as selectedTip.tip, but you can store all three if needed
    setSelectedTip({ 
      period, 
      tip: threeTips[0], // You can change this to show all three tips in your UI
      categoryIndex,
      allTips: threeTips // Store all tips for later use if needed
    });
    setSelectedCircle(`${period}-${categoryIndex}`);
    setCurrentTipIndex(prev => ({
      ...prev,
      [period]: categoryIndex
    }));
    setShowTutorial(true);

    if (period === "Daily") setCurrentForecast(forecastTables[0]);
    else if (period === "Monthly") setCurrentForecast(forecastTables[1]);
    else if (period === "Yearly") setCurrentForecast(forecastTables[2]);
  };

  const closeTip = () => {
    setSelectedTip(null);
    setSelectedCircle(null);
    setShowTutorial(false);
  };

  const getRelevanceRange = (value) => {
    console.log(`Getting relevance range for value: ${value}`);
    
    // Updated ranges to match your Excel data
    const ranges = [
      "21-40",   // Changed from "10-20" and "21-30", "31-40"
      "41-60",   // Changed from "41-50", "51-60" 
      "61-80",   // Changed from "61-70", "71-80"
      "80-100",  // Changed from "81-90", "91-100"
    ];
    
    for (let i = 0; i < ranges.length; i++) {
      const [min, max] = ranges[i].split("-").map(Number);
      if (value >= min && value <= max) {
        console.log(`Value ${value} falls in range: ${ranges[i]}`);
        return ranges[i];
      }
    }
    
    // Default fallback for values below 21
    if (value < 21) {
      console.log(`Value ${value} is below 21, defaulting to: 21-40`);
      return "21-40";
    }
    
    console.log(`Value ${value} doesn't match any range, defaulting to: 21-40`);
    return "21-40";
  };

  const getTipsForPeriod = async (period, table) => {
    const tips = await Promise.all(
      chartConfig.map(async (config) => {
        const value = table[config.key];
        //const value = table[config.label === "RELATIONSHIP" ? "RS" : config.label]; // Handle the RS/RELATIONSHIP mapping

        // Use the same relevance logic as getThreeTipsForChart
        const getRelevanceRange = (value) => {
          value = Number(value) || 0;
          if (value < 0) return "0-20";
          if (value <= 20) return "0-20";
          if (value > 20 && value <= 40) return "21-40";
          if (value > 40 && value <= 60) return "41-60";
          if (value > 60 && value <= 80) return "61-80";
          if (value > 80 && value <= 100) return "80-100";
          return "81-100";
        };

        const relevance = getRelevanceRange(value);

        // Use NATAL from lunarData for A2 in API call
        const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/booking/GetTips?period=${period.toLowerCase()}&A2=${lunarData?.NATAL}&category=${config.key}&score=${relevance}`;
        // const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/booking/GetTips?period=${period.toLowerCase()}&A2=${lunarData?.NATAL}&category=${config.label}&score=${relevance}`;
        console.log(
          `Fetching tip for period=${period}, A2=${lunarData?.NATAL}, category=${config.key}, score=${relevance}, url=${apiUrl}`
        );
        // console.log(
        //   `Fetching tip for period=${period}, A2=${lunarData?.NATAL}, category=${config.label}, score=${relevance}, url=${apiUrl}`
        // );
        // console.log(`[getTipsForPeriod] Value for ${config.label}:`, value);
        console.log(`[getTipsForPeriod] Value for ${config.key}:`, value);
        try {
          const response = await axios.get(apiUrl);
          const tip = response.data?.Table1?.[0]?.TIP || "No tip found.";
          console.log("Tip response:", tip);
          return {
            title: `${config.label}`,
            content: tip,
          };
        } catch (error) {
          console.error("Error fetching tip:", error.response || error.message);
          return {
            title: `${period} - ${config.label}`,
            content: "Error fetching tip.",
          };
        }
      })
    );

    setTipsData((prev) => ({ ...prev, [period]: tips }));
  };

  // Add this function near the top, after other utility functions
  const getThreeTipsForChart = async (period, chartLabel, table, lunarData) => {
  const apiPeriod = period.toLowerCase();

  // Helper to format category for API (still in English)
  const formatCategory = (label, type) => {
    if (label === "RS") {
      if (type === "total") return "General Relationship";
      if (type === "direct") return "Direct Relationship";
      if (type === "indirect") return "Indirect Relationship";
    }
    if (label === "WEALTH") {
      if (type === "total") return "General Wealth";
      if (type === "direct") return "Direct Wealth";
      if (type === "indirect") return "Indirect Wealth";
    }
    if (label === "CAREER") {
      if (type === "total") return "General Career";
      if (type === "direct") return "Direct Career";
      if (type === "indirect") return "Indirect Career";
    }
    if (label === "HEALTH") {
      if (type === "total") return "General Health";
      if (type === "direct") return "Direct Health";
      if (type === "indirect") return "Indirect Health";
    }
    if (label === "WISDOM") {
      if (type === "total") return "General Wisdom";
      if (type === "direct") return "Direct Wisdom";
      if (type === "indirect") return "Indirect Wisdom";
    }
    if (type === "total") return `General ${label.charAt(0) + label.slice(1).toLowerCase()}`;
    if (type === "direct") return `Direct ${label.charAt(0) + label.slice(1).toLowerCase()}`;
    if (type === "indirect") return `Indirect ${label.charAt(0) + label.slice(1).toLowerCase()}`;
    return label;
  };

  // Helper to create translated display label
  const getDisplayLabel = (chartLabel, type) => {
    const translatedLabel = chartConfig.find(c => c.key === chartLabel)?.label || chartLabel;
    if (type === "total") return `${t('natalChart.general')} ${translatedLabel}`;
    if (type === "direct") return `${t('natalChart.direct')} ${translatedLabel}`;
    if (type === "indirect") return `${t('natalChart.indirect')} ${translatedLabel}`;
    return translatedLabel;
  };

  const totalKey = chartLabel === "RS" ? "RS_TOTAL" : `${chartLabel}_TOTAL`;
  const part1Key = chartLabel === "RS" ? "RS" : chartLabel;
  const part2Key = chartLabel === "RS" ? "RS1" : `${chartLabel}1`;

  const getTip = async (category, value, displayLabel, isDirectIndirect = false) => {
    const getRelevanceRange = (value) => {
      value = Number(value) || 0;
      if (value < 0) return "0-20";
      if (value <= 20) return "0-20";
      if (value > 20 && value <= 40) return "21-40";
      if (value > 40 && value <= 60) return "41-60";
      if (value > 60 && value <= 80) return "61-80";
      if (value > 80 && value <= 100) return "80-100";
      return "81-100";
    };
    const getDirectIndirectRelevanceRange = (value) => {
      value = Number(value) || 0;
      if (value < 0) return "0-10";
      if (value <= 10) return "0-10";
      if (value > 10 && value <= 20) return "11-20";
      if (value > 20 && value <= 30) return "21-30";
      if (value > 30 && value <= 40) return "31-40";
      if (value > 40 && value <= 50) return "41-50";
      return "41-50";
    };

    const relevance = isDirectIndirect
      ? getDirectIndirectRelevanceRange(value)
      : getRelevanceRange(value);

    const score = relevance;
    const apiUrl = `https://xianhefairy.com/LotusFairy_API/api/booking/GetTips?period=${apiPeriod}&A2=${lunarData?.NATAL}&category=${category}&score=${score}`;
    console.log(`Fetching tip: period=${apiPeriod}, A2=${lunarData?.NATAL}, category=${category}, score=${score}, url=${apiUrl}`);
    try {
      const response = await axios.get(apiUrl);
      let tips = response.data?.Table1 || [];
      if (tips.length === 0) {
        return {
          title: displayLabel,
          content: "No tips available for this range.",
          relevance,
          chatHuman: "",
        };
      }
      tips = tips.sort((a, b) => b.ID - a.ID);
      const selectedTip = tips[0];
      const tipContent = selectedTip?.TIP || "No tip found.";
      return {
        title: displayLabel,
        content: tipContent,
        relevance: selectedTip?.RELEVANCE || "",
        chatHuman: selectedTip?.TIPS_CHAT_HUMAN || "",
      };
    } catch (error) {
      console.error(`Error fetching tip for ${category}:`, error);
      return {
        title: displayLabel,
        content: "Error fetching tip.",
        relevance,
        chatHuman: "",
      };
    }
  };

  const totalValue = table[totalKey] || 0;
  const part1Value = table[part1Key] || 0;
  const part2Value = table[part2Key] || 0;

  const baseCategory = chartLabel;

  const [totalTip, part1Tip, part2Tip] = await Promise.all([
    getTip(
      formatCategory(baseCategory, "total"),
      totalValue,
      getDisplayLabel(baseCategory, "total")
    ),
    getTip(
      formatCategory(baseCategory, "direct"),
      part1Value,
      getDisplayLabel(baseCategory, "direct"),
      true
    ),
    getTip(
      formatCategory(baseCategory, "indirect"),
      part2Value,
      getDisplayLabel(baseCategory, "indirect"),
      true
    ),
  ]);

  return [totalTip, part1Tip, part2Tip];
};

  const fetchForecastData = async (year, month, day, time) => {
    try {
      const response = await axios.get(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${time}`
      );
      const tables = [
        response.data.Table?.[0],
        response.data.Table1?.[0],
        response.data.Table2?.[0],
      ].filter(Boolean);

      //console.log("Forecast tables:", tables);

      if (tables.length === 3) {
        const [yearly, monthly, daily] = tables;
        setForecastTables([daily, monthly, yearly]);
        //setCurrentForecast(daily);
        await getTipsForPeriod("Daily", daily);
        await getTipsForPeriod("Monthly", monthly);
        await getTipsForPeriod("Yearly", yearly);
      } else {
        try {
          const fallbackRes = await axios.get(
            `https://xianhefairy.com/LotusFairy_API/api/member/GetNatalDailyForecast?cYear=${year}&cMonth=${month}&cDay=${day}`
          );
          const fallbackTables = [
            fallbackRes.data.Table?.[0],
            fallbackRes.data.Table1?.[0],
            fallbackRes.data.Table2?.[0],
          ].filter(Boolean);
          
          if (fallbackTables.length === 3) {
            const [yearly, monthly, daily] = fallbackTables;
            setForecastTables([daily, monthly, yearly]);
            await getTipsForPeriod("Daily", daily);
            await getTipsForPeriod("Monthly", monthly);
            await getTipsForPeriod("Yearly", yearly);
            return;
          }
        } catch(e) {
          console.error("Fallback fetch failed", e);
        }
        console.warn("Unexpected table data format:", response.data);
      }
    } catch (error) {
      console.error("Error fetching forecast data:", error);
    }
  };

  const userID = localStorage.getItem("userID");
  const userName = localStorage.getItem("username");
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [lunarData, setLunarData] = useState(null); // Store lunar data (NATAL)
  const [dob, setDob] = useState("");

  useEffect(() => {
    if (lunarData && forecastTables.length === 3) {
      getTipsForPeriod("Daily", forecastTables[0]);
      getTipsForPeriod("Monthly", forecastTables[1]);
      getTipsForPeriod("Yearly", forecastTables[2]);
    }
  }, [lunarData, forecastTables]);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://xianhefairy.com/LotusFairy_API/api/User/GetProfile",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            UserName: userName,
            ID: userID,
            UserToken: "",
            Token: {
              AccessToken:
                "xAfhn90xflfHfd.fjldfj@fdhLXHCHchlhsdflsdfhawWFRwzxxp",
            },
          }),
        }
      );

      const result = await response.json();
      if (response.ok && result.Profiles?.[0]) {
        const profile = result.Profiles[0];
        setEmail(profile.Email);
        setUsername(profile.FullName);
        setDob(profile.DOB);
        return profile;
      } else {
        throw new Error(`Error: ${response.status}`);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
      return null;
    }
  };

  const ModalHorizontalBar = ({ label, value, color }) => {
    // Clamp value to 0-60
    const v = Math.max(0, Math.min(Number(value) || 0, 60));

    // Segments: 0-10, 11-20, 21-30, 31-40, 41-50, 51-60
    const segments = [
      { min: 0, max: 10 },
      { min: 10.00001, max: 20 },
      { min: 20.00001, max: 30 },
      { min: 30.00001, max: 40 },
      { min: 40.00001, max: 50 },
      { min: 50.00001, max: 60 },
    ];

    // Find the segment max for the value
    const getSegmentMaxForValue = (val) => {
      if (val === 0) return 0;
      for (let i = 0; i < segments.length; i++) {
        const seg = segments[i];
        if (val > seg.min && val <= seg.max) return seg.max;
      }
      return 60;
    };

    const fillValue = getSegmentMaxForValue(v);
    const fillPercent = `${(fillValue / 60) * 100}%`;

    // Separator positions for 6 segments (10, 20, 30, 40, 50)
    const separatorPositions = [10, 20, 30, 40, 50];

    return (
      <div style={{ marginBottom: "18px" }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "8px",
          }}
        >
          <span style={{ fontWeight: "bold", color: "#DFBD69" }}>{label}</span>
        </div>
        <div
          style={{
            position: "relative",
            width: "100%",
            height: "28px",
            backgroundColor: "#1f1f1f",
            borderRadius: "14px",
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
          }}
          aria-hidden
        >
          {/* segments visual (6 equal parts) */}
          {Array.from({ length: 6 }).map((_, idx) => (
            <div
              key={idx}
              style={{
                width: "16.6667%",
                height: "100%",
                boxSizing: "border-box",
                borderRight:
                  idx < 5 ? "1px solid rgba(255,255,255,0.06)" : "none",
              }}
            />
          ))}

          {/* colored fill overlay */}
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              height: "100%",
              width: fillPercent,
              background: color,
              borderRadius: fillValue >= 60 ? "14px" : "14px 0 0 14px",
              transition: "width 0.3s ease",
              boxShadow: "inset 0 -2px 6px rgba(0,0,0,0.35)",
              zIndex: 1,
            }}
          />

          {/* vertical separators */}
          {separatorPositions.map((pos, idx) => (
            <div
              key={idx}
              style={{
                position: "absolute",
                left: `${(pos / 60) * 100}%`,
                top: 0,
                bottom: 0,
                width: "4px",
                backgroundColor: "#DFBD69",
                transform: "translateX(-50%)",
                pointerEvents: "none",
                zIndex: 2,
              }}
            />
          ))}
        </div>
      </div>
    );
  };

  const BarContainer = ({ children }) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        gap: "0px",
        marginBottom: "40px",
        width: "100%",
        alignItems: "center",
      }}
    >
      {children}
    </div>
  );

  useEffect(() => {
    const loadUserForecast = async () => {
      const user = await fetchData();
      if (user?.DOB) {
        const dob = new Date(user.DOB);
        const year = dob.getFullYear();
        const month = dob.getMonth() + 1;
        const day = dob.getDate();
        const hours = dob.getHours().toString().padStart(2, "0");
        const minutes = dob.getMinutes().toString().padStart(2, "0");
        const time = `${hours}:${minutes}`;

        fetchForecastData(year, month, day, time);
        fetchLunarData(year, month, day, time);
      }
    };

    loadUserForecast();
  }, []);

  const fetchLunarData = async (year, month, day, time = "22:59") => {
    try {
      const response = await axios.get(
        `https://xianhefairy.com/LotusFairy_API/api/member/GetLunarHeavenlyStems?cYear=${year}&cMonth=${month}&cDay=${day}&cTime=${time}`
      );
      const data = response.data?.[0];
      if (data) {
        setLunarData({
          ...data,
          NATAL: data.NATAL.trim(),
          STEM_RELATION: data.STEM_RELATION.trim(),
        });
        console.log("Lunar data fetched successfully:", data);
      }
    } catch (error) {
      console.error("Error fetching lunar data:", error);
    }
  };

  // for testing
  // useEffect(() => {
  //   // TEST DOB
  //   const year = 2001;
  //   const month = 1;
  //   const day = 1;
  //   const time = "22:59";
  //   fetchForecastData(year, month, day, time);
  //   fetchLunarData(year, month, day, time);
  // }, []);

  const getSelectedChartBreakdown = () => {
    if (!selectedTip || !forecastTables.length) return null;
    const { period, categoryIndex } = selectedTip;
    const table =
      period === "Daily"
        ? forecastTables[0]
        : period === "Monthly"
        ? forecastTables[1]
        : forecastTables[2];

    const config = chartConfig[categoryIndex];
    const labelKey = config.key; // Use the key for API queries
    const displayLabel = config.label; // Use the translated label for display
    
    // Use the key for database field names
    let part1 = table[labelKey === "RS" ? "RS" : labelKey] || 0;
    let part2 = table[labelKey === "RS" ? "RS1" : `${labelKey}1`] || 0;

    return {
      label: displayLabel, // This is already translated
      part1,
      part2,
    };
  };
  
  const selectedChartBreakdown = getSelectedChartBreakdown();

  const handleTipNav = (period, direction) => {
    setCurrentTipIndex((prev) => {
      const length = tipsData[period].length;
      let newIndex = prev[period] + (direction === "next" ? 1 : -1);
      if (newIndex < 0) newIndex = length - 1;
      if (newIndex >= length) newIndex = 0;
      return { ...prev, [period]: newIndex };
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        padding: "20px",
        boxSizing: "border-box",
        flexDirection: "row",
        position: "relative",
        backgroundColor: '#151517',
      }}
    >
      {/* MAIN CONTENT - CIRCLES ONLY */}
      {/* <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <h2 style={{ 
          color: "#DFBD69", 
          marginBottom: "15px",
          fontSize: "32px"
        }}>
          Your Natal Forecast
        </h2> */}
        
        {/* Daily Forecast */}
        {/* <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            Daily Forecast
          </h3>
          <CircleContainer>
          {forecastTables[0] &&
            chartConfig.map((config, i) => {
              // Map label to *_TOTAL field
              let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
              return (
                <SmallCircleProgress 
                  key={i}
                  onClick={() => handleCircleClick("Daily", i)}
                  isSelected={selectedCircle === `Daily-${i}`}
                >
                  <p style={{ 
                    color: "#DFBD69",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px"
                  }}>
                    {config.label}
                  </p>
                  <ProgressBarContainer>
                    <CircularProgressbar
                      value={forecastTables[0][key]}
                      text={`${forecastTables[0][key]}%`}
                      styles={buildStyles({
                        pathColor: config.color,
                        textColor: config.color,
                        textSize: "18px"
                      })}
                    />
                  </ProgressBarContainer>
                </SmallCircleProgress>
              );
            })}
        </CircleContainer>
        </div> */}

      {/* MAIN CONTENT - HORIZONTAL BARS ONLY */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
        }}
      >
        <h2 style={{ 
          color: "#DFBD69", 
          marginBottom: "15px",
          fontSize: "32px"
        }}>
          {/* {t('natalChart.yourLifeForecast')} */}
        </h2>
        
        {/* Daily Forecast */}
        <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            {t('natalChart.dailyForecast')}
          </h3>
          <CircleBarContainer>
            {forecastTables[0] &&
              chartConfig.map((config, i) => {
                let key = `${config.key}_TOTAL`;
                //let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <CircularBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[0][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Daily", i)}
                  />
                );
              })}
          </CircleBarContainer>
          {/* <BarContainer>
            {forecastTables[0] &&
              chartConfig.map((config, i) => {
                let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <HorizontalBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[0][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Daily", i)}
                  />
                );
              })}
          </BarContainer> */}
        </div>

        {/* Daily Tip - Shows only when Daily chart is clicked */}
        {showTutorial && selectedTip && selectedTip.period === "Daily" && (
          <div style={styles.tutorialContainer}>
            <button
              onClick={closeTip}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                backgroundColor: "transparent",
                border: "none",
                color: "#DFBD69",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 2,
              }}
            >
              X
            </button>
            {/* {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                }}
              >
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 1
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part1}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part1}%`}
                    styles={buildStyles({
                      pathColor: "#FFB347",
                      textColor: "#FFB347",
                    })}
                  />
                </div>
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 2
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part2}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part2}%`}
                    styles={buildStyles({
                      pathColor: "#87CEFA",
                      textColor: "#87CEFA",
                    })}
                  />
                </div>
              </div>
            )} */}

            {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row", // Show circles side by side
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                  marginTop: "40px"
                }}
              >
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                      label={`${t('natalChart.direct')} ${selectedChartBreakdown.label}`}
                      value={selectedChartBreakdown.part1}
                      color="#FFB347"
                    />
                </div>
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                    label={`${t('natalChart.indirect')} ${selectedChartBreakdown.label}`}
                    value={selectedChartBreakdown.part2}
                    color="#87CEFA"
                  />
                </div>
              </div>
            )}
            <div style={styles.paragraphsContainer}>
              <div style={styles.textsContainer}>
                {selectedTip.allTips && selectedTip.allTips.length > 0 ? (
                  <div style={{ width: "100%" }}>
                    {selectedTip.allTips.map((tip, idx) => (
                      <div key={idx} style={{ marginBottom: "18px", textAlign: "center" }}>
                        <h3
                          style={{
                            color: "#DFBD69",
                            marginTop: "5px",
                            marginBottom: "10px",
                            fontSize: "22px",
                            fontWeight: "bold",
                          }}
                        >
                          {tip.title}
                        </h3>
                        {/* Add relevance */}
                        {tip.relevance && (
                          <p style={{
                            ...styles.paragraphText,
                            fontSize: "16px",
                            color: "#DFBD69",
                            lineHeight: "1.5",
                            padding: "0 10px",
                          }}>
                            {tip.relevance}
                          </p>
                        )}
                        {/* Main content */}
                        <p style={{
                          ...styles.paragraphText,
                          fontSize: "16px",
                          color: "#DFBD69",
                          lineHeight: "1.5",
                          padding: "0 10px",
                        }}>
                          {tip.content}
                        </p>
                        {/* Add chatHuman if present */}
                        {tip.chatHuman && (
                          <p style={{
                            ...styles.paragraphText,
                            fontSize: "16px",
                            color: "#DFBD69",
                            lineHeight: "1.5",
                            padding: "0 10px",
                          }}>
                            {tip.chatHuman}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={styles.paragraphText}>Loading tutorial content...</p>
                )}
              </div>
            </div>
            {/* Chatbot Icon */}
            <div
              onClick={() => {
                setChatbotContext({
                  period: selectedTip.period,
                  categoryIndex: selectedTip.categoryIndex
                });
                setShowTipsChatbot(true);
              }}
              style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
                width: "50px",
                height: "50px",
                backgroundColor: "#DFBD69",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                zIndex: 10,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
          </div>
        )}



        {/* Chatbot Modal */}
        {showTipsChatbot && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)", // Edit overlay background here
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
            }}
            onClick={() => setShowTipsChatbot(false)}
          >
            <div
              style={{
                position: "relative",
                width: "90%",
                maxWidth: "500px", // Edit modal width here
                height: "80vh",
                maxHeight: "600px", // Edit modal height here
                backgroundColor: '#151517', // Edit modal background here
                borderRadius: "15px", // Edit border radius here
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)", // Edit shadow here
                border: "2px solid #DFBD69", // Edit border here
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div
                style={{
                  backgroundColor: "#DFBD69",
                  color: "#000",
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "13px 13px 0 0",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
              <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>
                Chat Fairy
              </h3>
                <button
                  onClick={() => setShowTipsChatbot(false)}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "#000",
                    padding: "5px",
                  }}
                >
                  ✕
                </button>
              </div>
      
              {/* Chatbot Content */}
              <div style={{ 
                flex: 1, 
                display: "flex", 
                flexDirection: "column",
                minHeight: 0, // Important: allows flex item to shrink below content size
                overflow: "hidden" // Prevent overflow on container
              }}>
                <div style={{ flex: 1, overflow: "hidden" }}>
                  <TipsChatbot 
                    key={selectedChartLabel}
                    selectedChart={selectedChartLabel === "RELATIONSHIP" ? "RS" : selectedChartLabel}
                    chartData={chartDataForChatbot}
                    period={selectedTip?.period || "daily"}
                  />
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Monthly Forecast - ADD THIS SECTION */}
        {/* <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            Monthly Forecast
          </h3>
          <CircleContainer>
          {forecastTables[1] &&
            chartConfig.map((config, i) => {
              // Map label to *_TOTAL field
              let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
              return (
                <SmallCircleProgress 
                  key={i}
                  onClick={() => handleCircleClick("Monthly", i)}
                  isSelected={selectedCircle === `Monthly-${i}`}
                >
                  <p style={{ 
                    color: "#DFBD69",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px"
                  }}>
                    {config.label}
                  </p>
                  <ProgressBarContainer>
                    <CircularProgressbar
                      value={forecastTables[1][key]}
                      text={`${forecastTables[1][key]}%`}
                      styles={buildStyles({
                        pathColor: config.color,
                        textColor: config.color,
                        textSize: "18px"
                      })}
                    />
                  </ProgressBarContainer>
                </SmallCircleProgress>
              );
            })}
        </CircleContainer>
        </div> */}

        <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            {t('natalChart.monthlyForecast')}
          </h3>
          <CircleBarContainer>
            {forecastTables[1] &&
              chartConfig.map((config, i) => {
                let key = `${config.key}_TOTAL`;
                //let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <CircularBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[1][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Monthly", i)}
                  />
                );
              })}
          </CircleBarContainer>
          {/* <BarContainer>
            {forecastTables[1] &&
              chartConfig.map((config, i) => {
                let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <HorizontalBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[1][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Monthly", i)}
                  />
                );
              })}
          </BarContainer> */}
        </div>

        {/* Monthly Tip - Shows only when Monthly chart is clicked */}
        {showTutorial && selectedTip && selectedTip.period === "Monthly" && (
          <div style={styles.tutorialContainer}>
            <button
              onClick={closeTip}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                backgroundColor: "transparent",
                border: "none",
                color: "#DFBD69",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 2,
              }}
            >
              X
            </button>
            {/* {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                }}
              >
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 1
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part1}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part1}%`}
                    styles={buildStyles({
                      pathColor: "#FFB347",
                      textColor: "#FFB347",
                    })}
                  />
                </div>
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 2
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part2}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part2}%`}
                    styles={buildStyles({
                      pathColor: "#87CEFA",
                      textColor: "#87CEFA",
                    })}
                  />
                </div>
              </div>
            )} */}
            {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row", // Show circles side by side
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                  marginTop: "40px"
                }}
              >
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                    label={`${t('natalChart.direct')} ${selectedChartBreakdown.label}`}
                    value={selectedChartBreakdown.part1}
                    color="#FFB347"
                  />
                </div>
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                    label={`${t('natalChart.indirect')} ${selectedChartBreakdown.label}`}
                    value={selectedChartBreakdown.part2}
                    color="#87CEFA"
                  />
                </div>
              </div>
            )}
            <div style={styles.paragraphsContainer}>
              <div style={styles.textsContainer}>
                {selectedTip.allTips && selectedTip.allTips.length > 0 ? (
                  <div style={{ width: "100%" }}>
                    {selectedTip.allTips.map((tip, idx) => (
                    <div key={idx} style={{ marginBottom: "18px", textAlign: "center" }}>
                      <h3
                        style={{
                          color: "#DFBD69",
                          marginTop: "5px",
                          marginBottom: "10px",
                          fontSize: "22px",
                          fontWeight: "bold",
                        }}
                      >
                        {tip.title}
                      </h3>
                      {/* Show relevance if present */}
                      {tip.relevance && (
                        <p style={{
                          ...styles.paragraphText,
                          fontSize: "16px",
                          color: "#DFBD69",
                          lineHeight: "1.5",
                          padding: "0 10px",
                        }}>
                          {tip.relevance}
                        </p>
                      )}
                      {/* Main content */}
                      <p style={{
                        ...styles.paragraphText,
                        fontSize: "16px",
                        color: "#DFBD69",
                        lineHeight: "1.5",
                        padding: "0 10px",
                      }}>
                        {tip.content}
                      </p>
                      {/* Show chatHuman if present */}
                      {tip.chatHuman && (
                        <p style={{
                          ...styles.paragraphText,
                          fontSize: "16px",
                          color: "#DFBD69",
                          lineHeight: "1.5",
                          padding: "0 10px",
                        }}>
                          {tip.chatHuman}
                        </p>
                      )}
                    </div>
                  ))}
                  </div>
                ) : (
                  <p style={styles.paragraphText}>Loading tutorial content...</p>
                )}
              </div>
            </div>
            {/* Chatbot Icon */}
            <div
              onClick={() => {
                setChatbotContext({
                  period: selectedTip.period,
                  categoryIndex: selectedTip.categoryIndex
                });
                setShowTipsChatbot(true);
              }}
              style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
                width: "50px",
                height: "50px",
                backgroundColor: "#DFBD69",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                zIndex: 10,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
          </div>
        )}

        {/* Chatbot Modal */}
        {showTipsChatbot && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)", // Edit overlay background here
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
            }}
            onClick={() => setShowTipsChatbot(false)}
          >
            <div
              style={{
                position: "relative",
                width: "90%",
                maxWidth: "500px", // Edit modal width here
                height: "80vh",
                maxHeight: "600px", // Edit modal height here
                backgroundColor: '#151517', // Edit modal background here
                borderRadius: "15px", // Edit border radius here
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)", // Edit shadow here
                border: "2px solid #DFBD69", // Edit border here
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div
                style={{
                  backgroundColor: "#DFBD69",
                  color: "#000",
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "13px 13px 0 0",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>
                  Chat Fairy
                </h3>
                <button
                  onClick={() => setShowTipsChatbot(false)}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "#000",
                    padding: "5px",
                  }}
                >
                  ✕
                </button>
              </div>
              
              {/* Chatbot Content */}
              <div style={{ 
                flex: 1, 
                display: "flex", 
                flexDirection: "column",
                minHeight: 0, // Important: allows flex item to shrink below content size
                overflow: "hidden" // Prevent overflow on container
              }}>
                <TipsChatbot 
                  key={selectedChartLabel}
                  selectedChart={selectedChartLabel === "RELATIONSHIP" ? "RS" : selectedChartLabel}
                  chartData={chartDataForChatbot}
                  period={selectedTip?.period || "monthly"}
                />
              </div>
            </div>
          </div>
        )}

        {/* Yearly Forecast - ADD THIS SECTION */}
        {/* <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            Yearly Forecast
          </h3>
          <CircleContainer>
          {forecastTables[2] &&
            chartConfig.map((config, i) => {
              // Map label to *_TOTAL field
              let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
              return (
                <SmallCircleProgress 
                  key={i}
                  onClick={() => handleCircleClick("Yearly", i)}
                  isSelected={selectedCircle === `Yearly-${i}`}
                >
                  <p style={{ 
                    color: "#DFBD69",
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "10px"
                  }}>
                    {config.label}
                  </p>
                  <ProgressBarContainer>
                    <CircularProgressbar
                      value={forecastTables[2][key]}
                      text={`${forecastTables[2][key]}%`}
                      styles={buildStyles({
                        pathColor: config.color,
                        textColor: config.color,
                        textSize: "18px"
                      })}
                    />
                  </ProgressBarContainer>
                </SmallCircleProgress>
              );
            })}
        </CircleContainer>
        </div> */}

        <div style={{ width: "100%" }}>
          <h3
            style={{
              color: "#DFBD69",
              textAlign: "center",
              marginBottom: "10px",
              fontSize: "24px"
            }}
          >
            {t('natalChart.yearlyForecast')}
          </h3>
          <CircleBarContainer>
            {forecastTables[2] &&
              chartConfig.map((config, i) => {
                let key = `${config.key}_TOTAL`;
                //let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <CircularBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[2][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Yearly", i)}
                  />
                );
              })}
          </CircleBarContainer>
          {/* <BarContainer>
            {forecastTables[2] &&
              chartConfig.map((config, i) => {
                let key = config.label === "RELATIONSHIP" ? "RS_TOTAL" : `${config.label}_TOTAL`;
                return (
                  <HorizontalBarChart
                    key={i}
                    label={config.label}
                    value={forecastTables[2][key]}
                    color={config.color}
                    onClick={() => handleCircleClick("Yearly", i)}
                  />
                );
              })}
          </BarContainer> */}
        </div>
        
        {/* Yearly Tip - Shows only when Yearly chart is clicked */}
        {showTutorial && selectedTip && selectedTip.period === "Yearly" && (
          <div style={styles.tutorialContainer}>
            <button
              onClick={closeTip}
              style={{
                position: "absolute",
                top: "15px",
                right: "15px",
                backgroundColor: "transparent",
                border: "none",
                color: "#DFBD69",
                fontSize: "20px",
                cursor: "pointer",
                zIndex: 2,
              }}
            >
              X
            </button>
            {/* {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                }}
              >
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 1
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part1}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part1}%`}
                    styles={buildStyles({
                      pathColor: "#FFB347",
                      textColor: "#FFB347",
                    })}
                  />
                </div>
                <div style={{ width: "120px", textAlign: "center" }}>
                  <p style={{ fontWeight: "bold", color: "#DFBD69" }}>
                    {selectedChartBreakdown.label} 2
                  </p>
                  <CircularProgressbar
                    value={selectedChartBreakdown.part2}
                    maxValue={50}
                    text={`${selectedChartBreakdown.part2}%`}
                    styles={buildStyles({
                      pathColor: "#87CEFA",
                      textColor: "#87CEFA",
                    })}
                  />
                </div>
              </div>
            )} */}
            {selectedChartBreakdown && (
              <div
                style={{
                  display: "flex",
                  flexDirection: "row", // Show circles side by side
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "30px",
                  marginBottom: "20px",
                  marginTop: "40px"
                }}
              >
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                    label={`${t('natalChart.direct')} ${selectedChartBreakdown.label}`}
                    value={selectedChartBreakdown.part1}
                    color="#FFB347"
                  />
                </div>
                <div style={{ width: "200px", textAlign: "center" }}>
                  <ModalCircleProgress
                    label={`${t('natalChart.indirect')} ${selectedChartBreakdown.label}`}
                    value={selectedChartBreakdown.part2}
                    color="#87CEFA"
                  />
                </div>
              </div>
            )}
            <div style={styles.paragraphsContainer}>
              <div style={styles.textsContainer}>
                {selectedTip.allTips && selectedTip.allTips.length > 0 ? (
                  <div style={{ width: "100%" }}>
                    {selectedTip.allTips.map((tip, idx) => (
                      <div key={idx} style={{ marginBottom: "18px", textAlign: "center" }}>
                        <h3
                          style={{
                            color: "#DFBD69",
                            marginTop: "5px",
                            marginBottom: "10px",
                            fontSize: "22px",
                            fontWeight: "bold",
                          }}
                        >
                          {tip.title}
                        </h3>
                        {/* Show relevance if present */}
                        {tip.relevance && (
                          <p style={{
                            ...styles.paragraphText,
                            fontSize: "16px",
                            color: "#DFBD69",
                            lineHeight: "1.5",
                            padding: "0 10px",
                          }}>
                            {tip.relevance}
                          </p>
                        )}
                        {/* Main content */}
                        <p style={{
                          ...styles.paragraphText,
                          fontSize: "16px",
                          color: "#DFBD69",
                          lineHeight: "1.5",
                          padding: "0 10px",
                        }}>
                          {tip.content}
                        </p>
                        {/* Show chatHuman if present */}
                        {tip.chatHuman && (
                          <p style={{
                            ...styles.paragraphText,
                            fontSize: "16px",
                            color: "#DFBD69",
                            lineHeight: "1.5",
                            padding: "0 10px",
                          }}>
                            {tip.chatHuman}
                          </p>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <p style={styles.paragraphText}>Loading tutorial content...</p>
                )}
              </div>
            </div>
            {/* Chatbot Icon */}
            <div
              onClick={() => {
                setChatbotContext({
                  period: selectedTip.period,
                  categoryIndex: selectedTip.categoryIndex
                });
                setShowTipsChatbot(true);
              }}
              style={{
                position: "absolute",
                bottom: "10px",
                right: "10px",
                width: "50px",
                height: "50px",
                backgroundColor: "#DFBD69",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
                boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                zIndex: 10,
                transition: "transform 0.3s ease",
              }}
              onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
              onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
            >
              <svg
                width="25"
                height="25"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#000000"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
              </svg>
            </div>
          </div>
        )}

        {/* Chatbot Modal */}
        {showTipsChatbot && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.8)", // Edit overlay background here
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 1001,
            }}
            onClick={() => setShowTipsChatbot(false)}
          >
            <div
              style={{
                position: "relative",
                width: "90%",
                maxWidth: "500px", // Edit modal width here
                height: "80vh",
                maxHeight: "600px", // Edit modal height here
                backgroundColor: '#151517', // Edit modal background here
                borderRadius: "15px", // Edit border radius here
                display: "flex",
                flexDirection: "column",
                overflow: "hidden",
                boxShadow: "0 20px 60px rgba(0, 0, 0, 0.4)", // Edit shadow here
                border: "2px solid #DFBD69", // Edit border here
              }}
              onClick={(e) => e.stopPropagation()}
            >
              {/* Header */}
              <div
                style={{
                  backgroundColor: "#DFBD69",
                  color: "#000",
                  padding: "10px 20px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  borderRadius: "13px 13px 0 0",
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                }}
              >
                <h3 style={{ margin: 0, fontSize: "18px", fontWeight: "bold" }}>
                  Chat Fairy
                </h3>
                <button
                  onClick={() => setShowTipsChatbot(false)}
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                    color: "#000",
                    padding: "5px",
                  }}
                >
                  ✕
                </button>
              </div>
              
              {/* Chatbot Content */}
              <div style={{ 
                flex: 1, 
                display: "flex", 
                flexDirection: "column",
                minHeight: 0, // Important: allows flex item to shrink below content size
                overflow: "hidden" // Prevent overflow on container
              }}>
                <div style={{ flex: 1, overflow: "hidden" }}>
                  <TipsChatbot 
                    key={selectedChartLabel}
                    selectedChart={selectedChartLabel === "RELATIONSHIP" ? "RS" : selectedChartLabel}
                    chartData={chartDataForChatbot}
                    period={selectedTip?.period || "yearly"}
                  />
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = {
  tutorialContainer: {
    maxWidth: "600px", // Match NatalChart.jsx
    width: "100%",     // Match NatalChart.jsx
    margin: "auto",
    position: "relative",
    padding: "20px",   // Match NatalChart.jsx
    borderRadius: "10px",
    backgroundColor: "#242324",
    marginBottom: "50px",
    paddingBottom: "40px",
    justifyContent: "center",
    alignItems: "center",
    height: "auto",
    overflow: "hidden",
  },

  paragraphsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    height: "auto",
    padding: "10px 0", // Added padding for vertical spacing
  },
  
  textsContainer: {
    display: "flex",
    justifyContent: "center",
    padding: "0 20px", // Added horizontal padding
  },

  paragraphText: {
    fontSize: "18px",
    margin: "15px 0", // Added margin for better text spacing
  },
};

export default ForecastChart;